/*
  AironiMenager — profondeur 3D au défilement (voir am-3d.css).

  Rien ne se passe si l'utilisateur préfère moins d'animations. Les sections
  déjà visibles au chargement ne sont jamais masquées : seules celles situées
  plus bas attendent d'entrer dans l'écran.
*/
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const main = document.querySelector('main');
  if (!main) return;

  /* 1. Sections qui se redressent en entrant dans l'écran.
     Pas d'IntersectionObserver : il ne voit pas une section qu'on a
     « sautée » (retour arrière, ancre, défilement très rapide) et la
     laisserait invisible. Ici, toute section dont le haut est passé sous
     les 88 % de la hauteur d'écran est révélée — y compris celles déjà
     dépassées vers le haut. */
  const sections = [...main.querySelectorAll(':scope > .shopify-section')].slice(1);
  const enAttente = new Set();

  sections.forEach((section) => {
    // Barre d'achat collante, sections vides : jamais d'effet (un parent
    // transformé décalerait un élément en position fixe).
    if (section.offsetHeight < 40 || section.querySelector('.am-barre, [class*="sticky"]')) return;
    section.querySelectorAll('.grid__item, .am-situation__tuile, .collection-list__item').forEach((el, i) => {
      el.style.setProperty('--am-i', i % 8);
    });
    section.classList.add('am-3d');
    // Déjà atteinte au chargement (en haut de page ou page rouverte plus bas) : visible tout de suite.
    if (section.getBoundingClientRect().top < window.innerHeight * 0.9) return;
    section.classList.add('am-3d--attente');
    enAttente.add(section);
  });

  // Appel direct au défilement (une dizaine de sections : coût négligeable).
  // Pas de requestAnimationFrame ici : il est suspendu dans les onglets en
  // arrière-plan et certains navigateurs intégrés, ce qui figerait la page.
  const reveler = () => {
    const limite = window.innerHeight * 0.88;
    enAttente.forEach((section) => {
      if (section.getBoundingClientRect().top < limite) {
        section.classList.remove('am-3d--attente');
        enAttente.delete(section);
      }
    });
    if (!enAttente.size) {
      window.removeEventListener('scroll', reveler);
      window.removeEventListener('resize', reveler);
      clearInterval(filet);
    }
  };
  // Filet de sécurité : certains navigateurs retardent les événements de
  // défilement (onglet en arrière-plan, restauration de position). Une
  // vérification toutes les 400 ms garantit qu'aucune section atteinte ne
  // reste invisible. Elle s'arrête dès que tout est révélé.
  let filet;
  if (enAttente.size) {
    window.addEventListener('scroll', reveler, { passive: true });
    window.addEventListener('resize', reveler, { passive: true });
    filet = setInterval(reveler, 400);
    reveler();
  }

  /* 2. Grand visuel : parallaxe liée au défilement. */
  const hero = main.querySelector(':scope > .shopify-section:first-child .banner');
  if (hero) {
    hero.classList.add('am-3d-hero');
    let attente = false;
    const majHero = () => {
      attente = false;
      const h = hero.offsetHeight || 1;
      const p = Math.min(Math.max(window.scrollY / h, 0), 1);
      hero.style.setProperty('--am-p', p.toFixed(3));
    };
    window.addEventListener(
      'scroll',
      () => {
        if (!attente) {
          attente = true;
          requestAnimationFrame(majHero);
        }
      },
      { passive: true }
    );
    majHero();
  }

  /* 3. Inclinaison vers la souris (ordinateur uniquement). */
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const INCLINAISON = 7; // degrés maximum
  const brancher = (el) => {
    if (el.dataset.amIncline) return;
    el.dataset.amIncline = '1';
    el.classList.add('am-inclinable');
    if (getComputedStyle(el).position === 'static') el.style.position = 'relative';

    el.addEventListener('pointermove', (e) => {
      const r = el.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width;
      const y = (e.clientY - r.top) / r.height;
      el.classList.add('am-inclinable--actif');
      el.style.setProperty('--am-ry', `${(x - 0.5) * INCLINAISON * 2}deg`);
      el.style.setProperty('--am-rx', `${(0.5 - y) * INCLINAISON * 2}deg`);
      el.style.setProperty('--am-ty', '-6px');
      el.style.setProperty('--am-mx', `${x * 100}%`);
      el.style.setProperty('--am-my', `${y * 100}%`);
    });
    el.addEventListener('pointerleave', () => {
      el.classList.remove('am-inclinable--actif');
      ['--am-rx', '--am-ry', '--am-ty'].forEach((v) => el.style.removeProperty(v));
    });
  };

  const brancherTout = (racine = document) =>
    racine.querySelectorAll('.card-wrapper .card, .am-situation__tuile, .collection-list__item .card').forEach(brancher);

  brancherTout();
  // Grilles rechargées (filtres de collection, recommandations) : on rebranche.
  new MutationObserver(() => brancherTout()).observe(main, { childList: true, subtree: true });
})();
